import React, {useEffect, useState} from 'react';

//import * as LogFunctions from './../Helpers/LogFunctions';
import {
    ActivityIndicator,
    AlertModal,
    CCText,
    View
} from '../../../custom-packages/react-native-components-in-react/react-native-components-in-react';


import {useSelector} from 'react-redux';
import {BorderlessButton, ThemeButton} from '../../../custom-packages/react-button-package/ButtonPackage';


import * as MaskFunctions from '@chocostack/maskifier';
import AppConfig from '../../../AppConfig';
import ChocoForm from '../../../custom-packages/react-chocoforms/legacy/ChocoForm';

import Styles from "../../../Styles";
import PencilIcon from "../../../assets/custom-icons/PencilIcon";
import {GetLang} from "../../../LocalStorageFunctions";

const TFoodPricing = {
    // English
    "enUS": {
        'NEW_FOOD': 'New Food',
        'TITLE_FORM': 'Name (Ex. Small, Medium, etc)',
        'TITLE': 'Descriptive Name',
        'PRICE': 'Price',
        'CURRENCY': 'Currency',
        'SAVE': 'Save',
        'CANCEL': 'Cancel',
        'EDIT': 'Edit',
        'DELETE_PRICING': 'Delete Price',
        'DELETE_PRICING_TEXT': 'Deleting the price will remove it from any menu it was added to',
        'DELETE': 'Delete',
        'BASE_PRICE': 'Base Price'
    },
    // Spanish
    "esMX": {
        'NEW_FOOD': 'Nuevo Alimento',
        'TITLE_FORM': 'Nombre (Ej. Chico, Mediano, etc)',
        'TITLE': 'Nombre Descriptivo',
        'PRICE': 'Precio',
        'CURRENCY': 'Moneda',
        'SAVE': 'Guardar',
        'CANCEL': 'Cancelar',
        'EDIT': 'Editar',
        'DELETE_PRICING': 'Eliminar Precio',
        'DELETE_PRICING_TEXT': 'Eliminar el precio lo removerá de cualquier menú al que haya sido agregado',
        'DELETE': 'Eliminar',
        'BASE_PRICE': 'Precio Base'
    }
}

const FoodPricing = (props) => {
    const auth = useSelector(state => state.Auth);

    const [saving, setSaving] = useState(false);
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);

    const [deleted, setDeleted] = useState(false)
    const [editable, setEditable] = useState(props.editable)

    const [alertOpen, setAlertOpen] = useState(false)
    const [alertData, setAlertData] = useState({
        title: '',
        text: '',
        buttons: []
    })

    const initialControls = {
        fpr_title: {
            elementType: 'input',
            label: TFoodPricing[AppConfig.lang].TITLE_FORM,
            elementConfig: {
                placeholder: TFoodPricing[AppConfig.lang].TITLE_FORM,
                autoCapitalize: 'words'
            },
            value: props.item ? props.item.fpr_title : '',
            validation: {
                required: true,
                maxLength: 25
            },
            valid: false,
            touched: false,
        },
        fpr_price: {
            elementType: 'currency',
            label: TFoodPricing[AppConfig.lang].PRICE,
            elementConfig: {
                placeholder: TFoodPricing[AppConfig.lang].PRICE,
                autoCapitalize: 'none',
            },
            className: 'col-6',
            value: props.item ? props.item.fpr_price : '',
            validation: {
                required: true,
                min: 1
            },
            valid: false,
            touched: false,
        },
        fpr_currency: {
            elementType: 'select',
            elementConfig: {
                autoCapitalize: 'words'
            },
            className: 'col-6',
            value: props.item ? props.item.fpr_currency : GetLang() === AppConfig.LANG_ES_MX ? AppConfig.CURRENCIES[0] : AppConfig.CURRENCIES[1],
            options: AppConfig.CURRENCIES.map(c => ({
                label: c,
                value: c
            })),
            validation: {
                required: true
            },
            valid: false,
            touched: false,
        },
    };

    const [form, setForm] = useState({
        id: props.id,
        controls: initialControls,
    });

    const toggleDeleteAlert = () => {
        if (!alertOpen) {
            setAlertData({
                title: TFoodPricing[AppConfig.lang].DELETE_PRICING,
                text: TFoodPricing[AppConfig.lang].DELETE_PRICING_TEXT,
                buttons: [{
                    text: TFoodPricing[AppConfig.lang].CANCEL,
                    onPress: () => {
                    }
                }, {
                    text: TFoodPricing[AppConfig.lang].DELETE,
                    onPress: async () => {
                        try {
                            setSaving(true)

                            const response = await fetch(AppConfig.URL + '/Food/DeletePricing/' + props.item.fpr_id, {
                                method: 'GET',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json',
                                    'Authorization': auth.token
                                },
                            });

                            const data = await response.json();

                            if (data.success) {
                                setDeleted(true)
                            }
                        } catch (e) {
                            setSaving(false)
                        }
                    }
                }],
            })
        }

        setAlertOpen(!alertOpen)
    }

    const saveFoodPrice = async () => {
        const controls = {...form.controls};

        if (form.isValidForm) {
            try {
                setSaving(true);
                setSaveButtonDisabled(true);

                let formData = {};

                if (props.item)
                    formData['fpr_id'] = props.item.fpr_id;

                formData['FPR_FOOD_ID'] = props.foodID;

                for (let key in controls) {
                    formData[key] = controls[key].value;
                }

                const response = await fetch(AppConfig.URL + '/Food/CreatePricing/', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': auth.token
                    },
                    body: JSON.stringify(formData)
                });

                const data = await response.json();

                if (data.success) {
                    if (props.onSuccess)
                        props.onSuccess(data.foodPrice)
                    else
                        setEditable(false)
                }
            } catch (e) {
                console.log(e)
            }

            setSaving(false);
        } else {

        }
    }

    // Controls when to show the title in the form
    useEffect(() => {
        setForm(prevForm => {
            let updatedControls = {...prevForm.controls};

            if (props.hideName) {
                delete updatedControls.fpr_title;
            } else {
                updatedControls = {fpr_title: initialControls.fpr_title, ...updatedControls};
            }

            return {...prevForm, controls: updatedControls};
        });
    }, [props.hideName]);

    if (deleted)
        return null;

    return (
        <View
            style={{overflow: 'initial', ...props.style}}
            className={'card'}
        >
            <View
                style={{paddingBottom: 1}}
                className={'card-body'}
            >
                {
                    editable ?
                        <View>
                            <ChocoForm
                                containerStyle={{padding: 0}}
                                lang={AppConfig.lang}
                                form={form}
                                onFormChange={(updatedForm) => {
                                    setForm(updatedForm);
                                    setSaveButtonDisabled(!updatedForm.isValidForm)

                                    if (props.returnForm)
                                        props.returnForm(updatedForm)
                                }}
                            />
                            {
                                props.foodID ?
                                    <View style={{marginBottom: 15, flexDirection: 'row', justifyContent: 'flex-end'}}>
                                        {saving ?
                                            <ActivityIndicator style={{marginRight: 7}}/>
                                            :
                                            <View style={{flexDirection: 'row'}}>
                                                <BorderlessButton
                                                    text={TFoodPricing[AppConfig.lang].CANCEL}
                                                    onPress={() => {
                                                        if (props.onCancel)
                                                            props.onCancel();
                                                        else
                                                            setEditable(false)
                                                    }}
                                                />
                                                <View style={{width: 7}}></View>
                                                <ThemeButton
                                                    disabled={saveButtonDisabled}
                                                    text={TFoodPricing[AppConfig.lang].SAVE}
                                                    onPress={async () => {
                                                        if (props.foodID)
                                                            await saveFoodPrice();
                                                        else
                                                            setEditable(false)
                                                    }}
                                                />
                                            </View>
                                        }
                                    </View>
                                    :
                                    null
                            }
                            <View
                                style={{
                                    marginBottom: 10,
                                    flexDirection: 'row',
                                    justifyContent: 'flex-end'
                                }}
                            >
                                {
                                    props.deletableWhileEditing ?
                                        <BorderlessButton
                                            textStyle={{...Styles.redColor}}
                                            text={TFoodPricing[AppConfig.lang].DELETE}
                                            onPress={() => {

                                                if (props.onDelete)
                                                    props.onDelete(form);
                                                else
                                                    toggleDeleteAlert();
                                            }}
                                        />
                                        :
                                        null
                                }
                            </View>
                        </View>
                        :
                        <View>
                            <h4 style={{marginBottom: 10, ...Styles.textColor}}>
                                {form.controls.fpr_title.value}
                            </h4>
                            <View style={{flexDirection: 'row', justifyContent: 'space-between'}}>
                                <View style={{flexDirection: 'row', marginBottom: 10}}>
                                    <CCText style={{fontSize: 20}}>
                                        {MaskFunctions.maskMoney(form.controls.fpr_price.value)}
                                    </CCText>
                                    <CCText style={{marginLeft: 7, fontSize: 20}}>
                                        {form.controls.fpr_currency.value}
                                    </CCText>
                                </View>
                                <View style={{flexDirection: 'row', justifyContent: 'flex-end'}}>
                                    {
                                        saving ?
                                            <ActivityIndicator style={{marginBottom: 10, marginRight: 7}}/>
                                            :
                                            <View style={{flexDirection: 'row'}}>
                                                <BorderlessButton
                                                    icon={<PencilIcon size={15} style={{marginTop: 4,}}/>}
                                                    text={TFoodPricing[AppConfig.lang].EDIT}
                                                    onPress={() => {
                                                        setEditable(!editable)
                                                    }}
                                                />
                                                {props.deletable ?
                                                    <BorderlessButton
                                                        textStyle={{...Styles.redColor}}
                                                        text={TFoodPricing[AppConfig.lang].DELETE}
                                                        onPress={() => {

                                                            if (props.onDelete)
                                                                props.onDelete(form);
                                                            else
                                                                toggleDeleteAlert();
                                                        }}
                                                    />
                                                    :
                                                    null
                                                }
                                            </View>
                                    }
                                </View>
                            </View>
                        </View>
                }
                <AlertModal
                    visible={alertOpen}
                    onRequestClose={toggleDeleteAlert}
                    title={alertData.title}
                    text={alertData.text}
                    buttons={alertData.buttons}
                />
            </View>
        </View>
    );
}

export default FoodPricing;